import { AddButton } from './form/templates/AddButton'
import { ArrayFieldDescriptionTemplate } from './form/templates/ArrayFieldDescriptionTemplate'
import { ArrayFieldItemTemplate } from './form/templates/ArrayFieldItemTemplate'
import { ArrayFieldTitleTemplate } from './form/templates/ArrayFieldTitleTemplate'
import { BaseInputTemplate } from './form/templates/BaseInputTemplate'
import { CheckboxWidget } from './form/widgets/CheckboxWidget'
import { DescriptionFieldTemplate } from './form/templates/DescriptionFieldTemplate'
import { ErrorListTemplate } from './form/templates/ErrorListTemplate'
import { FieldTemplate } from './form/templates/FieldTemplate'
import { MultiSelectWidget } from './form/widgets/MultiSelectWidget'
import { ObjectFieldTemplate } from './form/templates/ObjectFieldTemplate'
import { RadioWidget } from './form/widgets/RadioWidget'
import { RegistryFieldsType, type RegistryWidgetsType } from '@rjsf/utils'
import { RemoveButton } from './form/templates/RemoveButton'
import { SelectDueDateWidget } from './form/widgets/SelectDueDateWidget'
import { SelectWidget } from './form/widgets/SelectWidget'
import { TextareaWidget } from './form/widgets/TextareaWidget'
import { InputWithSubTextWidget } from './form/widgets/InputWithSubTextWidget'
import { SelectWithSubTextWidget } from './form/widgets/SelectWithSubTextWidget'
import { SelectSubstancesWidget } from './form/widgets/SelectSubstancesWidget'
import { SelectProductWidget } from './form/widgets/SelectProductWidget'
import { SelectMatrixWidget } from './form/widgets/SelectMatrixWidget'
import { SelectPayloadSchemaWidget } from './form/widgets/SelectPayloadSchemaWidget'
import { MarkdownEditorWidget } from './form/widgets/MarkdownEditorWidget'
import { VassdragField } from './form/fields/VassdragField'

export const widgets: RegistryWidgetsType = {
  TextareaWidget,
  SelectWidget,
  RadioWidget,
  CheckboxWidget,
  multiSelectWidget: MultiSelectWidget,
  selectDueDateWidget: SelectDueDateWidget,
  InputWithSubTextWidget,
  SelectWithSubTextWidget,
  selectSubstancesWidget: SelectSubstancesWidget,
  selectProductWidget: SelectProductWidget,
  selectMatrixWidget: SelectMatrixWidget,
  selectPayloadSchemaWidget: SelectPayloadSchemaWidget,
  markdownEditorWidget: MarkdownEditorWidget
}

export const fields: RegistryFieldsType = {
  VassdragField
}

export const templates = {
  ObjectFieldTemplate,
  FieldTemplate,
  BaseInputTemplate,
  DescriptionFieldTemplate,
  ArrayFieldTitleTemplate,
  ArrayFieldDescriptionTemplate,
  ArrayFieldItemTemplate,
  ErrorListTemplate,
  ButtonTemplates: {
    AddButton,
    RemoveButton
  }
}
